import { AsyncStoreItem } from '@lib/store';
import { EncryptDutyFreePreOrderResponse } from 'src/sdk-servicing';

/**
 * EncryptDutyFreePreorderResult model
 */
export interface EncryptDutyFreePreorderResultModel {
  model: EncryptDutyFreePreOrderResponse | null;
}

/**
 *  EncryptDutyFreePreorderResultModel model details
 */
export interface EncryptDutyFreePreorderResultStateDetails extends AsyncStoreItem {}

/**
 * EncryptDutyFreePreorderResult store state
 */
export interface EncryptDutyFreePreorderResultState
  extends EncryptDutyFreePreorderResultStateDetails,
    EncryptDutyFreePreorderResultModel {}

/**
 * Name of the EncryptDutyFreePreorderResult Store
 */
export const ENCRYPT_DUTY_FREE_PREORDER_RESULT_STORE_NAME = 'encryptDutyFreePreorderResult';

/**
 * EncryptDutyFreePreorderResult Store Interface
 */
export interface EncryptDutyFreePreorderResultStore {
  /** EncryptDutyFreePreorderResult state */
  [ENCRYPT_DUTY_FREE_PREORDER_RESULT_STORE_NAME]: EncryptDutyFreePreorderResultState;
}
